import {
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Checkbox,
  Button,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import { ReactComponent as IconEdit } from "../../../../images/iconEdit.svg";

const MedicamentoItem = ({ item, index }) => {
  return (
    <Stack
      sx={{
        border: "1px solid #1E729F",
        padding: "8px 16px",
        marginBottom: "16px",
        borderRadius: "5px",
        boxShadow: "0px 1px 8px 0px #00000026 !important",
      }}
      key={index}
      className="medicamentoItem"
    >
      <Stack
        direction="row"
        sx={{
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <Stack direction="row" sx={{ alignItems: "center" }}>
          <Checkbox sx={{ color: "#1E729F" }}></Checkbox>
          <Typography className="title">
            {item.substancia} - {item.nomeMedicamento} - {item.apresentacao}
          </Typography>
        </Stack>
      </Stack>
      <Stack sx={{ pl: "2.5rem" }}>
        <Typography className=" title" sx={{ fontSize: "16px !important" }}>
          Duração do tratamento:{" "}
          <Typography className="subTitle" component="span">
            {item.duracaoTratamento.replace("-", " ")}
          </Typography>
        </Typography>
      </Stack>
      <Stack sx={{ pl: "2.5rem" }}>
        <Typography className="title" sx={{ fontSize: "16px !important" }}>
          Posologia:{" "}
          <Typography className="subTitle" component="span">
            {item.posologia}
          </Typography>
        </Typography>
      </Stack>
      <Stack sx={{ pl: "2.5rem" }}>
        <Typography className="title" sx={{ fontSize: "16px !important" }}>
          Observação:{" "}
          <Typography className="subTitle" component="span">
            {item.observacao}
          </Typography>
        </Typography>
      </Stack>
    </Stack>
  );
};

export default function PrescricaoMedicamentos({ data, small }) {
  return (
    <Accordion defaultExpanded={false} className="AccordionContainer">
      <AccordionSummary
        expandIcon={<ExpandMore style={{ color: "#1E729F" }} />}
        aria-controls="PrescricaoMedicamentos-content"
        id="PrescricaoMedicamentos-header"
        className={`AccordionSummaryContainer ${small ? "small" : ""}`}
      >
        <Stack direction="row" alignItems="center" gap="8px " height="30px">
          <IconEdit style={{ width: "24px" }} />
          <Typography className={`Accordion_title ${small ? "small" : ""}`}>
            Prescrição de medicamentos
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Button
          sx={{
            color: "darkgray",
            textTransform: "none",
            textDecoration: "underline",
            fontSize: "1.1rem",
            pl: "2.5rem",
          }}
        >
          Gerar receita
        </Button>

        {data.map((medicamento, index) => (
          <MedicamentoItem index={index} item={medicamento} />
        ))}
      </AccordionDetails>
    </Accordion>
  );
}
